import React from 'react';
import people from '../../assets/people.png';
import header from '../../assets/header.png';
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">Protecting Your Rights, Serving Your Needs</h1>
      <p>We endeavor to provide our clients with a network of innovative legal solutions, excellent legal representation and a dedication to quality client service.</p>

      <div className="gpt3__header-content__input">
        <input type="email" placeholder="Your Email Address" />
        <button type="button">Get Started</button>
      </div>

      <div className="gpt3__header-content__people">
        <img src={people} />
        <p>1,600 people requested access a visit in last 24 hours</p>
      </div>
    </div>

    <div className="gpt3__header-image">
      <img src={header} />
    </div>
  </div>
);

export default Header;
